export default "__VITE_ASSET__C8l0$B$R__"